import { cn } from '@/lib/utils'
import { Chip } from '@/ui/components'
import React, { memo } from 'react'

export interface TourInfoProps extends React.HTMLAttributes<HTMLDivElement> {
  distance?: string
  duration?: string
  altitudeUphill?: string
  altitudeDownhill?: string
}

const TourInfo = ({
  distance,
  duration,
  altitudeUphill,
  altitudeDownhill,
  className,
  ...props
}: TourInfoProps) => {
  if (!distance && !duration && !altitudeUphill && !altitudeDownhill) {
    return null
  }

  return (
    <div
      className={cn('gap-sm md:gap-gutter flex flex-wrap', className)}
      {...props}
    >
      {distance && (
        <Chip
          size="s"
          variant="ghost"
          iconLeft="material-symbols:arrow-range"
          className="px-0!"
        >
          {distance}
        </Chip>
      )}
      {duration && (
        <Chip size="s" variant="ghost" iconLeft="mdi:clock" className="px-0!">
          {duration}
        </Chip>
      )}
      {altitudeUphill && (
        <Chip
          size="s"
          variant="ghost"
          iconLeft="mdi:arrow-drop-up"
          className="px-0!"
        >
          {`${altitudeUphill} hm`}
        </Chip>
      )}
      {altitudeDownhill && (
        <Chip
          size="s"
          variant="ghost"
          iconLeft="mdi:arrow-drop-down"
          className="px-0!"
        >
          {`${altitudeDownhill} hm`}
        </Chip>
      )}
    </div>
  )
}

export default memo(TourInfo)
